import { render } from "./infoModal.vue?vue&type=template&id=71302460&scoped=true"
import script from "./infoModal.vue?vue&type=script&lang=js"
export * from "./infoModal.vue?vue&type=script&lang=js"

import "./infoModal.vue?vue&type=style&index=0&id=71302460&scoped=true&lang=scss"
import "./infoModal.vue?vue&type=style&index=1&id=71302460&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71302460"]])

export default __exports__